import { render, staticRenderFns } from "./asignar-coevaluacion.vue?vue&type=template&id=2824416d"
import script from "./asignar-coevaluacion.vue?vue&type=script&lang=js"
export * from "./asignar-coevaluacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports